import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import { getBackendFlowKey } from '../routing/getBackendFlowKey';
export const getNewUserHubletChoice = () => {
  return noAuthApiClient.post('signup/v1/location/new-user-available-hublets', {
    data: {
      flowKey: getBackendFlowKey()
    }
  });
};